module.exports = {
      id: "3d-tour-usage",
      viewBox: "0 0 20 23",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#3d-tour",
      toString: function () {
        return this.url;
      }
    }